import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ConfigurazioneHome, ConfigurazioneStagione, GalleriaSpettacolo, News, Spettacolo } from '../../shared/interface';
import { ApiService } from '../../services/api.service';
import { DatePipe } from '@angular/common';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit, AfterViewInit {

  constructor(private apiService: ApiService, private datePipe: DatePipe, private cdr: ChangeDetectorRef) { }

  @ViewChild('video') video?: ElementRef<HTMLVideoElement>

  stagione?: ConfigurazioneStagione;
  configurazione_home?: ConfigurazioneHome;
  news: News[] = [];
  galleria: GalleriaSpettacolo[] = [];
  spettacoli: Spettacolo[] = [];
  spettacolo_evidenza?: Spettacolo;

  video_spettacolo: string = '';

  loading: boolean = false;
  muted: boolean = true;

  active: number = 0;

  get hasCustomVideo(): boolean {
    return !!this.configurazione_home?.attivo
      && this.configurazione_home.tipo === 'video'
      && !!this.configurazione_home.video;
  }

  get hasCustomImmagine(): boolean {
    return !!this.configurazione_home?.attivo
      && this.configurazione_home.tipo === 'immagine'
      && !!this.configurazione_home.immagine;
  }

  get showPulsanteHome(): boolean {
    const config = this.configurazione_home;
    if (!config?.testo_link) return false;
    if (config.tipo_pulsante === 'file') return !!config.file;
    return !!config.link;
  }

  get isPulsanteFile(): boolean {
    return this.configurazione_home?.tipo_pulsante === 'file';
  }

  get showSpettacoloEvidenza(): boolean {
    return !this.hasCustomVideo && !this.hasCustomImmagine && !!this.spettacolo_evidenza;
  }

  get showDefaultVideo(): boolean {
    return !this.hasCustomVideo && !this.hasCustomImmagine && !this.spettacolo_evidenza;
  }

  get showVideo(): boolean {
    return this.hasCustomVideo
      || this.showDefaultVideo
      || (this.showSpettacoloEvidenza && this.video_spettacolo.length > 0);
  }

  get showSpettacoloImmagine(): boolean {
    return this.showSpettacoloEvidenza && this.video_spettacolo.length <= 0;
  }

  /** Mobile: img_home (stile box); fallback cover. Desktop: cover. */
  get evidenzaImgMobile(): string {
    const s = this.spettacolo_evidenza;
    return s?.img_home || s?.img_copertina || '';
  }

  get evidenzaImgDesktop(): string {
    return this.spettacolo_evidenza?.img_copertina || '';
  }

  ngOnInit(): void {
    addEventListener('scroll', () => {
      if (document.getElementById('logo-circle')) {
        document.getElementById('logo-circle')!.style.transform = 'rotate(' + window.scrollY / 10 + 'deg)';
      }
      if (document.getElementById('logo-circle-archivio')) {
        document.getElementById('logo-circle-archivio')!.style.transform = 'rotate(' + window.scrollY / 10 + 'deg)';
      }
    })

    this.loading = true;

    forkJoin({
      home: this.apiService.getConfigurazioneHome(),
      stagione: this.apiService.getConfigurazioneStagione(),
      spettacoli: this.apiService.getSpettacoli(),
      notizie: this.apiService.getNotizie(),
    }).subscribe({
      next: ({ home, stagione, spettacoli, notizie }) => {
        this.configurazione_home = home;
        this.stagione = stagione;
        this.applySpettacoli(spettacoli);
        this.news = [...notizie.slice(0, 8)];
        this.loadGalleriaEvidenza();
      },
      error: (err) => {
        this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Errore caricamento home');
        this.loading = false;
      },
    });
  }

  private applySpettacoli(data: Spettacolo[]): void {
    this.spettacoli = [...data.filter(spettacolo => {
      const date = spettacolo.calendario!.length > 0 && spettacolo.calendario!.length <= 1 ? this.datePipe.transform(spettacolo.calendario![0].data, 'yyyy-MM-dd') + " " + spettacolo.calendario![0].orario : (spettacolo.calendario!.length == 0 ? this.datePipe.transform(spettacolo!.al, 'yyyy-MM-dd') : this.datePipe.transform(spettacolo.calendario![spettacolo.calendario!.length - 1].data, 'yyyy-MM-dd') + " " + spettacolo.calendario![spettacolo.calendario!.length - 1].orario)
      const time = new Date(date || '').getTime() - new Date().getTime();
      if (time > 300000)
        return spettacolo;
      else
        return null;
    })];

    this.spettacolo_evidenza = data.filter(spettacolo => spettacolo.evidenzia)[0];
  }

  private loadGalleriaEvidenza(): void {
    if (this.showSpettacoloEvidenza && this.spettacolo_evidenza) {
      this.apiService.getGalleriaSpettacolo(this.spettacolo_evidenza.id).subscribe({
        next: (data) => this.galleria = [...data.filter(file => file.type == 'video' && file.evidenza)],
        error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
        complete: () => {
          if (this.galleria.length > 0) {
            this.video_spettacolo = this.galleria[0].file;
          }
          this.loading = false;
        }
      });
    } else {
      this.loading = false;
    }
  }

  getVideoSrc(): string {
    if (this.hasCustomVideo) {
      return this.configurazione_home!.video + '?type=video';
    }
    if (this.showSpettacoloEvidenza && this.video_spettacolo.length > 0) {
      return this.video_spettacolo + '?type=video';
    }
    return 'teatrocolosseo.mov?type=video';
  }

  ngAfterViewInit(): void {
    this.muted = this.video?.nativeElement.muted ?? true;

    if (this.video) {
      this.video.nativeElement.loop = true;
      this.video.nativeElement.playsInline = true;
      this.video.nativeElement.preload = 'metadata';
      this.video.nativeElement.volume = 0.5;
      this.video.nativeElement.autoplay = true;
    }
  }

  onPause(event: Event) {
    if (this.video) {
      this.video.nativeElement.play();
    }
  }

  onMute(muted: boolean) {
    this.video!.nativeElement.muted = !muted;
    this.muted = !muted
  }

  onChangeSlide(slide: any) {
    this.active = slide;
    this.cdr.detectChanges();
  }

}
